import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {Location} from '@angular/common';
import { AbstractControl, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MeesageDialogComponent } from 'src/app/admin/dialog/meesage-dialog/meesage-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { FormsConfirmationMessageComponent } from '../dialogs/forms-confirmation-message/forms-confirmation-message.component';
import { Links, RtaAttachements } from 'src/app/shared/models/admin.model';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { UserRepositoryService } from 'src/app/services/user-repository.service';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { User } from 'src/app/shared/models/user.model';
import { RTAStatus, UserRoles } from 'src/app/app.constants';
import { SolarFormsRepositoryService } from 'src/app/services/solarForms/solar-forms-repository.service';
import { SupplierDetails } from 'src/app/shared/models/documents.model';
import { RTADetails } from 'src/app/shared/models/solarForms.model';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { DocumentsRepositoryService } from 'src/app/services/documents-repository.service';


@Component({
  selector: 'app-create-rta-form',
  templateUrl: './create-rta-form.component.html',
  styleUrls: ['./create-rta-form.component.scss']
})
export class CreateRTAFormComponent implements OnInit {
  //today = new Date();
  //tomorrow = new Date();
  RTAForm: UntypedFormGroup;
  restrictPattern =  '^[^\\/"<>|*?]+$';
  integersPattern =  '^[0-9]+$';
  //"^[a-zA-Z0-9!@#%^&()_+\-=\[\]{};':&quot;,.?&lt;&gt;\\ ]+$";
  //"^[\\/*?&quot;&lt;&gt;|]+$";      
  //"^[^\\/*?&quot;&lt;&gt;|]*$";

  @ViewChild('scrollSection',{static: false}) scrollSection: ElementRef;
  @ViewChild('scrollToProposed',{static: false}) scrollToProposed: ElementRef;
  isProposedDurationValid: boolean;
  linkList: Links[] = [];
  private unsubscribe: Subject<void> = new Subject<void>();
  user: User;
  supplierResults: any[];
  fileResponse: any;
  linkListAddress: string;
   acceptedFileExtensions = [];
  isQauntityRequire: boolean;
  quantityInvalid: boolean = true;
  isRTAFormDirty: boolean;
  supllierInfo: SupplierDetails;
  //makeButtonDisable: boolean;
  getEditRTAInfo: any;
  generalRTAInformation: any;
  rtaReqDetails: any;
  rtaCurrentCondition: any;
  isRTAEditForm: boolean = false;
  rtaDisposition: any;
  supplierIndex: number;
  isRTAReadOnly: boolean = false;
  isLoadingData: boolean;
  isRTASaveDraft: boolean = false;
  isRTAFormSubmit: boolean;

  constructor(private fb: UntypedFormBuilder,
              private documentsService: DocumentsRepositoryService,
              private navigationPreviousPage: Location,
              private dialog: MatDialog,
              private snackBarService: SnackBarService,
              private route: ActivatedRoute,
              private userRepositoryService: UserRepositoryService,
              private solarFormsService: SolarFormsRepositoryService) { 
    
  }

  ngOnInit(): void {
    this.rtaFormInitialize();
    this.addRemoveValidators();
    this.userRepositoryService.loggedUserData$
     .pipe(takeUntil(this.unsubscribe))
     .subscribe((user) => { 
       this.user = user;
     this.userRepositoryService.getSuppliersByUserId(user.cwsId)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        const supplierFiltered = res.filter(function (el) {
          return el != null;
        });
        this.route.paramMap.subscribe((params: ParamMap) => {
          let id = params.get('status');
          if (id != 'createRTA') {
            this.editFormInitliaze(id);
            this.supplierResults = supplierFiltered;
            this.showSupplier();
          } else {
            if (this.user.roleId === UserRoles.SUPPLIER || this.user.roleId === UserRoles.SUPPLIER_ENG_QUALITY) {
              this.supplierResults = supplierFiltered;
              this.showSupplier();
              //this.isLoadingData = true;
            } else {
              this.RTAForm.disable();
              this.isRTAReadOnly = true;
            }
          }
        });
      });
    });
  }

  editFormInitliaze(id) {
    this.solarFormsService.getRTAFormDetailsById(id)
      .pipe(takeUntil(this.unsubscribe)).subscribe((data) => {
        this.getEditRTAInfo = data;
        if(this.getEditRTAInfo) {
          this.isRTAEditForm = true;
          this.generalRTAInformation = data.generalRTAInformation;
          this.rtaReqDetails = data.rtaRequestDetails;
          this.rtaCurrentCondition = data.rtaCurrentCondition;
          this.rtaDisposition = data.rtsDisposition;
          this.editFormValueBinding();
          if(this.user) {
          if((this.user.roleId === UserRoles.ADMIN || this.user.roleId === UserRoles.SUPPLYCHAIN || this.user.roleId === UserRoles.ENGINEERING) && 
          (this.generalRTAInformation.rtaStatus == RTAStatus.Approved || this.generalRTAInformation.rtaStatus == RTAStatus.Draft ||
             this.generalRTAInformation.rtaStatus == RTAStatus.Submitted)
            ) {
            this.readOnlyRTAForm();
           } else if ((this.user.roleId === UserRoles.SUPPLIER || this.user.roleId === UserRoles.SUPPLIER_ENG_QUALITY) &&
             (this.generalRTAInformation.rtaStatus == RTAStatus.Approved)) {
             this.readOnlyRTAForm();
          }
        }
        }
      });
  }

  editFormValueBinding() {
   this.supplierResults.filter((val, i )=>{
      if(val.organizationCode == this.rtaReqDetails.supplierCode){
        this.supplierIndex = i;
      }
    })
    this.currentCondition.clear();
    //this.supplierResults = this.rtaReqDetails;
    this.supplierReference.patchValue(this.generalRTAInformation.supplierPreference);
    this.supplierOrCamName.patchValue(this.supplierResults[this.supplierIndex]);
    this.email.patchValue(this.rtaReqDetails.email);
    this.phone.patchValue(this.rtaReqDetails.phone);
    this.solarPurchaseOrder.patchValue(this.rtaReqDetails.solarPurchaseOrderNumber);
    this.solarProductionOrder.patchValue(this.rtaReqDetails.solarProductionNumber);
    this.operation.patchValue(this.rtaReqDetails.operationNumber);
    //this.isNonconformingConditionCtq.patchValue(this.rtaReqDetails.isNonconformingConditionCTQ == false ? 'No' : 'Yes');
    this.isNonconformingConditionCtq.patchValue(this.rtaReqDetails.isNonconformingConditionCTQ == false ? 'No' : (this.rtaReqDetails.isNonconformingConditionCTQ == true ? 'Yes' : null) ),
    this.causeOfNonconformance.patchValue(this.rtaReqDetails.causeOfNonConformance);
    this.proposedCorrection.patchValue(this.rtaReqDetails.proposeCorrection);
    this.commentsOrSrp.patchValue(this.rtaReqDetails.comments);
    this.quantityOfNonconformingParts.patchValue(this.rtaReqDetails.proposedDuration.quantityOfNonconformingParts);
    this.fromDate.patchValue(this.rtaReqDetails.proposedDuration.fromDate);
    this.toDate.patchValue(this.rtaReqDetails.proposedDuration.toDate);
    this.rtaCurrentCondition.currentConditions.forEach(val => {
      const formgroup = new UntypedFormGroup({
        drawingOrSpecRequirement: this.fb.control(val.drawingSpecRequirement == null ? '' : val.drawingSpecRequirement, [Validators.required]),
        bluePrintZoneSection: this.fb.control(val.bluePrintZoneSpecSection == null ? '' : val.bluePrintZoneSpecSection, [Validators.required]),
        //isCtq: this.fb.control(val.isCTQ == true ? 'Yes' : 'No', [Validators.required]) , // == true ? 'Yes' : 'No',
        isCtq: this.fb.control(val.isCTQ == true ? 'Yes' : (val.isCTQ == false ? 'No' : null), [Validators.required]) , // == true ? 'Yes' : 'No',
        actualCondition: this.fb.control(val.actualCondition, [Validators.required]),
        quantity: this.fb.control(val.quantity, [Validators.required]),
        serialNumber:  this.fb.control(val.serialNumber == null ? '' : val.serialNumber),
        additionalComments: this.fb.control(val.additionalComments == null ? '' : val.additionalComments),
        disposition:  this.fb.control(val.disposition == null ? '' : val.disposition),
        dispositionNotes: this.fb.control(val.dispositionNotes == null ? '' : val.dispositionNotes),
      });

      this.currentCondition.push(formgroup);
    });
    this.linkList = this.rtaCurrentCondition.rtaAttachments;
    // if(this.generalRTAInformation.rtaStatus == 'Draft') {
    //    // this.isSaveDraft
    // }
  }

  readOnlyRTAForm() {
    this.RTAForm.disable();
    this.isRTAReadOnly = true;
  }

  private showSupplier(): void {
    const getSupplier = this.supplierResults.filter(
      (x) => x.id === this.user.supplierId
    );
    this.supllierInfo = getSupplier[0];
    this.supplierOrCamName.setValue(getSupplier[0]);
    this.email.setValue(this.user.email);
  }

  rtaFormInitialize() {
    this.RTAForm = this.fb.group({
      supplierReference: this.fb.control('', [Validators.pattern(this.restrictPattern), this.backSlashValidator]),
      rtaRequestDetails: this.fb.group({
        supplierOrCamName: this.fb.control('',[Validators.required]),
        phone: this.fb.control('',[Validators.required, Validators.pattern(this.restrictPattern), this.backSlashValidator]),
        email: this.fb.control('',[Validators.required, this.multipleEmailValidator, this.backSlashValidator, Validators.pattern(this.restrictPattern)]),
        solarPurchaseOrder: this.fb.control('', [Validators.pattern(this.restrictPattern), this.backSlashValidator]),
        solarProductionOrder: this.fb.control('', [Validators.pattern(this.restrictPattern), this.backSlashValidator]),
        operation: this.fb.control('', [Validators.pattern(this.restrictPattern), this.backSlashValidator]),
        isNonconformingConditionCtq: this.fb.control('',[Validators.required]),
        causeOfNonconformance: this.fb.control('',[Validators.required, Validators.pattern(this.restrictPattern), this.backSlashValidator]),
        proposedCorrection: this.fb.control('',[Validators.required, Validators.pattern(this.restrictPattern), this.backSlashValidator]),
        commentsOrSrp: this.fb.control('',[Validators.required, Validators.pattern(this.restrictPattern), this.backSlashValidator]),
        quantityOfNonconformingParts: this.fb.control(''),
        fromDate: this.fb.control(''),
        toDate: this.fb.control(''),
      }),
      currentCondition: this.fb.array([
        this.fb.group({
          drawingOrSpecRequirement: this.fb.control('',[Validators.required]),
          bluePrintZoneSection: this.fb.control('',[Validators.required]),
          isCtq: this.fb.control('',[Validators.required]),
          actualCondition: this.fb.control('',[Validators.required]),
          quantity: this.fb.control(''),
          serialNumber: this.fb.control(''),
          additionalComments: this.fb.control(''),
          disposition: this.fb.control('-'),
          dispositionNotes: this.fb.control('-'),
        })
      ]),
      filesUploadAttachment: this.fb.control('')
    });
    this.quantityOfNonconformingParts.valueChanges.pipe(debounceTime(500), distinctUntilChanged())
    .subscribe(val => {
      if(val) {
        let ctrl;
        if(this.currentCondition) {
          this.currentCondition.controls.forEach(a => {
            ctrl = a;
             ctrl.controls.quantity.setValidators([Validators.required]);
             ctrl.controls.quantity.updateValueAndValidity();
             //this.quantityInvalid = true;
             //ctrl.controls.quantity.markAsTouched();
             this.isQauntityRequire = true;
          })
        }
      } else {
        let ctrl;
        if(this.currentCondition) {
          this.currentCondition.controls.forEach(a => {
            ctrl = a;
             ctrl.controls.quantity.clearValidators();
             ctrl.controls.quantity.updateValueAndValidity();
             this.isQauntityRequire = false;
          })
        }
      }
    });
    this.RTAForm.valueChanges
    .subscribe(val => {
      if(this.RTAForm.dirty) {
        this.isRTAFormDirty = true;
      }
    });
    this.toDate.valueChanges.pipe(debounceTime(500), distinctUntilChanged())
    .subscribe(val => {
      if(val) {
        this.validateDates();
      }
    });
    this.fromDate.valueChanges.pipe(debounceTime(500), distinctUntilChanged())
    .subscribe(val => {
      if(val) {
        this.validateDates();
      }
    });
  }

   validateDates() {
    const from = new Date(this.fromDate.value);
    const to = new Date(this.toDate.value);
    if(from && to && from > to) {
      this.toDate.setErrors({ dateRangeError: true });
    } else {
      this.toDate.setErrors(null);
    }
   }

  backSlashValidator(control: UntypedFormControl) {
    const value = control.value;
    const hasBackSlash = value && value.includes('\\');
    return hasBackSlash ? {'hasBackSlash' : true } : null;
  }

  multipleEmailValidator(control: UntypedFormControl) { 
    const value = control.value; 
    if (value) { 
      const emailArray = value.split(','); 
      const isValid = emailArray.every(email => /\S+@\S+\.\S+/.test(email.trim())); 
      return isValid ? null : { multipleEmails: true }; 
    } 
    return null;
  }

  onAddConditionClick() {
    const newEntry = new UntypedFormGroup({
      drawingOrSpecRequirement: this.fb.control('',[Validators.required]),
      bluePrintZoneSection: this.fb.control('',[Validators.required]),
      isCtq: this.fb.control('',[Validators.required]),
      actualCondition: this.fb.control('',[Validators.required]),
      quantity: this.fb.control('', [this.quantityOfNonconformingParts.value != '' ? Validators.required : Validators.nullValidator]),
      serialNumber: this.fb.control(''),
      additionalComments: this.fb.control(''),
      disposition: this.fb.control('-'),
      dispositionNotes: this.fb.control('-'),
    });
    this.currentCondition.push(newEntry);
  }

  onDeleteIconClick(index) {
    this.currentCondition.controls.splice(index, 1);
    this.currentCondition.value.splice(index, 1);
    if (this.currentCondition.controls.length > 0) {
      this.currentCondition.controls.forEach((formGroup: AbstractControl) => {
        if (formGroup instanceof UntypedFormGroup) {
          Object.keys(formGroup.controls).forEach((ctrlName: string) => {
            const control = formGroup.get(ctrlName);
            if (control instanceof UntypedFormControl && control.validator) {
              control.updateValueAndValidity();
            }
          })
        }
      });
    } else {
      this.currentCondition.setErrors({ inValidCondition: true });
    }
  }

  onRtaFormSubmit() {
    if (this.RTAForm.valid) {
      if(((!this.RTAForm.get('rtaRequestDetails.fromDate').value) || (!this.RTAForm.get('rtaRequestDetails.toDate').value)) && !this.RTAForm.get('rtaRequestDetails.quantityOfNonconformingParts').value) {
        this.isProposedDurationValid = true;
        this.scrollToProposed.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }else {
        this.isRTAFormSubmit = true;
        const RTAFormInfo = this.getRTAFormInfo();
        this.isProposedDurationValid = false;
        const dialogRef = this.dialog.open(FormsConfirmationMessageComponent, {
          disableClose: true,
          width: '650px',
          data: {
            name: 'Submit RTA',
            message: 'Do you wish to submit this RTA to be reviewed by Solar?',
            data: RTAFormInfo,
            isRTAEdit: this.isRTAEditForm
          }
        });
      }
        // submit the form
     } else {
      let scrollToIndex = -1;
      let ctrl;
      let firstInvalid = null;
      this.currentCondition.controls.find((control, index) => {
        if (control.status == 'INVALID' && scrollToIndex === -1) {
          ctrl = control;
          for(let key in ctrl.controls) {
            const invalidField = ctrl.get(key);
            if(invalidField.invalid) {
              firstInvalid = invalidField;
              break;
            }
          }
          scrollToIndex = index;
        }
      });
      if (scrollToIndex !== -1) {
        const element = document.getElementById(`scrollSection-${scrollToIndex}`);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        if(firstInvalid) {
          //firstInvalid.focus();
          firstInvalid.markAsTouched();
        }
      }
    }
  }

  onRtaSaveDraftClick() {
    this.isRTASaveDraft = true;
    this.isLoadingData = true;
    const RTAFormInfo = this.getRTAFormInfo();
    if(!this.isRTAEditForm) {
      this.solarFormsService.saveRTAFormInfo(RTAFormInfo)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((data) => {
        if(data) {
          this.snackBarService.showSuccess(`RTA draft saved successfully.`); 
          this.navigationPreviousPage.back();
          this.isLoadingData = false; 
        }else{
          this.snackBarService.showError('An error has occurred. Please try again later.'); 
          this.navigationPreviousPage.back();
          this.isLoadingData = false; 
        } 
      }, (error) => {
        if (error.status == 400) {
          this.snackBarService.showError("Invalid input!");
          this.isLoadingData = false;
        }
        else {
          this.isLoadingData = false;
        }
      });
    } else {
      this.solarFormsService.updateRTAFormDetails(RTAFormInfo)
      .pipe(takeUntil(this.unsubscribe))
        .subscribe((data) => {
          if (data) {
            this.snackBarService.showSuccess(`RTA draft saved successfully.`);
            this.navigationPreviousPage.back();
            this.isLoadingData = false;
          } else {
            this.snackBarService.showError('An error has occurred. Please try again later.');
            this.navigationPreviousPage.back();
            this.isLoadingData = false;
          }
        }, (error) => {
          if (error.status == 400) {
            this.snackBarService.showError("Invalid input!");
            this.isLoadingData = false;
          }
          else {
            this.isLoadingData = false;
          }
        });
    }
    
  }

  getRTAFormInfo() {
  
  let RTADetails: RTADetails;
  if(this.isRTAEditForm) {
    RTADetails = {
      generalRTAInformation: {
        rtaNumber: this.generalRTAInformation.rtaNumber,
        rtaRevison: this.generalRTAInformation.rtaRevison,
        submittedBy: this.generalRTAInformation.submittedBy,
        submittedDate: this.generalRTAInformation.submittedDate,
        rtaStatus:  this.isRTAFormSubmit ? 'Submitted' : this.generalRTAInformation.rtaStatus,
        supplierPreference: this.supplierReference.value,
      },
      rtaRequestDetails: {
        supplierCode: this.supplierOrCamName.value.organizationCode,
        supplierName: this.supplierOrCamName.value.supplierName,
        phone: this.phone.value,
        email: this.email.value == null ? 'null' : this.email.value,
        solarPurchaseOrderNumber: this.solarPurchaseOrder.value,
        solarProductionNumber: this.solarProductionOrder.value,
        operationNumber: this.operation.value,
        isNonconformingConditionCTQ: (this.isNonconformingConditionCtq.value == 'Yes' ? true : (this.isNonconformingConditionCtq.value == 'No' ? false : null)),
        // isNonconformingConditionCTQ: this.isNonconformingConditionCtq.value == 'Yes' ? true : false,
        causeOfNonConformance: this.causeOfNonconformance.value,
        proposeCorrection: this.proposedCorrection.value,
        comments: this.commentsOrSrp.value,
        proposedDuration: {
          quantityOfNonconformingParts: this.quantityOfNonconformingParts.value,
          fromDate: this.fromDate.value,
          toDate: this.toDate.value,
        }
      },
      RTACurrentCondition: {
        CurrentConditions: this.currentCondition.controls.map((control: UntypedFormGroup) => {
          return {
            drawingSpecRequirement: control.get('drawingOrSpecRequirement').value,
            bluePrintZoneSpecSection: control.get('bluePrintZoneSection').value,
            isCtq: control.get('isCtq').value == 'Yes' ? true : (control.get('isCtq').value == 'No' ? false : null),
            //isCtq: control.get('isCtq').value == 'Yes' ? true : false,
            actualCondition: control.get('actualCondition').value,
            quantity: control.get('quantity').value,
            serialNumber: control.get('serialNumber').value,
            AdditionalComments: control.get('additionalComments').value,
            disposition: control.get('disposition').value,
            dispositionNotes: control.get('dispositionNotes').value,
          };
        }),
        RTAAttachments: this.linkList.map(val => {
          return {
            linkTitle: val.linkTitle,
            linkAddress: val.linkAddress
          }
        }),
      },
      rtsDisposition: this.rtaDisposition != null ?  {
        additionalSolarComments: this.rtaDisposition.additionalSolarComments,
        changeRequest: this.rtaDisposition.changeRequest,
        deviationPermit: this.rtaDisposition.deviationPermit,
        partIdentificationLocationMethod: this.rtaDisposition.partIdentificationLocationMethod,
        problemReportECRNo: this.rtaDisposition.problemReportECRNo,
        solarApprovedPeriod: this.rtaDisposition.solarApprovedPeriod,
        totalQuantityOfParts: this.rtaDisposition.totalQuantityOfParts,
      } : null
    } 
  } else {
    RTADetails = {
      generalRTAInformation: {
        rtaNumber: '',
        rtaRevison: '',
        submittedBy: '',
        submittedDate: '',
        rtaStatus: this.isRTASaveDraft ? 'Draft' : 'Submitted',
        supplierPreference: this.supplierReference.value,
      },
      rtaRequestDetails: {
        supplierCode: this.supplierOrCamName.value.organizationCode,
        supplierName: this.supplierOrCamName.value.supplierName,
        phone: this.phone.value,
        email: this.email.value,
        solarPurchaseOrderNumber: this.solarPurchaseOrder.value,
        solarProductionNumber: this.solarProductionOrder.value,
        operationNumber: this.operation.value,
        isNonconformingConditionCTQ: (this.isNonconformingConditionCtq.value == 'Yes' ? true : (this.isNonconformingConditionCtq.value == 'No' ? false : null)),
       // isNonconformingConditionCTQ: this.isNonconformingConditionCtq.value == 'Yes' ? true : false,
        causeOfNonConformance: this.causeOfNonconformance.value,
        proposeCorrection: this.proposedCorrection.value,
        comments: this.commentsOrSrp.value,
        proposedDuration: {
          quantityOfNonconformingParts: this.quantityOfNonconformingParts.value,
          fromDate: this.fromDate.value,
          toDate: this.toDate.value,
        }
      },
      RTACurrentCondition: {
        CurrentConditions: this.currentCondition.controls.map((control: UntypedFormGroup) => {
          return {
            drawingSpecRequirement: control.get('drawingOrSpecRequirement').value,
            bluePrintZoneSpecSection: control.get('bluePrintZoneSection').value,
           // isCtq: control.get('isCtq').value == 'Yes' ? true : false,
           isCtq: control.get('isCtq').value == 'Yes' ? true : (control.get('isCtq').value == 'No' ? false : null),
            actualCondition: control.get('actualCondition').value,
            quantity: control.get('quantity').value,
            serialNumber: control.get('serialNumber').value,
            AdditionalComments: control.get('additionalComments').value,
            disposition: '',
            dispositionNotes: '',
          };
        }),
        RTAAttachments: this.linkList.map(val => {
          return {
            linkTitle: val.linkTitle,
            linkAddress: val.linkAddress
          }
        }),
      }
    } 
  }
   
    return RTADetails;
  }

  onKeyDown(event: KeyboardEvent) {
    const keyCode = event.keyCode || event.which;
    if([8, 46, 37, 39].indexOf(keyCode) !== -1) {
      return;
    }
    if(keyCode < 48 || keyCode > 57) {
      event.preventDefault();
    }
  }

  fileUpload() {
    document.getElementById("filesUpload").click();
  }

  addRemoveValidators(): void {
    this.acceptedFileExtensions = [];
      this.documentsService
          .getValidFileExtensions()
          .pipe(takeUntil(this.unsubscribe))
          .subscribe(
            (response:[]) => {
              this.acceptedFileExtensions.push(response);
            })
    }

  onFileSelected(event) {
    let fileValue = this.filesUploadAttachment.value;
    let abc = this.supplierOrCamName.value.organizationCode+'_'+event.target.files[0].name;
    let modifiedName = new File([event.target.files[0]], abc);

    let fileExtensionValue = fileValue.split('.');
     for (let i = 0; i < this.linkList.length; i++) {
      if (this.linkList[i].linkAddress === event.target.files[0].name) {
        this.snackBarService.showError(event.target.files[0].name + ' ' + 'file is Already uploaded');
      }
    }

    if (fileValue) { 
      let fileSize = this.linkList.reduce((n, { linksize }) => n + linksize, 0);
      if (fileSize > 1000000000) {
        this.snackBarService.showError('Only attachments up to 1GB are allowed');
      } else {
        if (this.linkList.length < 100) {
          const file: File = modifiedName;
          let formData: FormData = new FormData();
          let linkList: any = new Object();
          let fileExtensionValueWithdot = '.'+fileExtensionValue[1];
          formData.append("file", file);
          if(this.supplierOrCamName.value){
            formData.append("SupplierCode", this.supplierOrCamName.value.organizationCode);
            formData.append("SupplierName", this.supplierOrCamName.value.supplierName)
          }
             if((this.acceptedFileExtensions[0].indexOf(fileExtensionValue[1].toString()) > -1) || (this.acceptedFileExtensions[0].indexOf(fileExtensionValueWithdot.toString()) > -1)){
              this.solarFormsService.uploadRTAContent(formData).pipe(takeUntil(this.unsubscribe))
                .subscribe(
                  (response: string) => {
                    if (response) {
                      this.linkListAddress = response;
                      linkList.linkTitle = event.target.files[0].name;
                     // linkList.linksize = event.target.files[0].size;
                      linkList.linkAddress = this.linkListAddress;
                      this.linkList.push(linkList);
                    }
                    this.filesUploadAttachment.patchValue("");
                  },
                  (error) => {
                    console.log(error)
                  });
              }    
            else{
              this.snackBarService.showError(' Not Valid File extension');
            }
         }
        else {
          this.snackBarService.showError('Only 100 attachments can be added');
          return;
        }
      }
    }
  }

  removeLinkList(index) {
        this.linkList.splice(index, 1);
  }

  onClickBackOrClose(){
    if(this.isRTAFormDirty) {
      const message = 'Changes you made may not be saved.';
      const res = window.confirm(message);
      if(res) {
        this.navigationPreviousPage.back();
      }
    } else {
      this.navigationPreviousPage.back();
    }
  }

  get supplierReference() {
    return this.RTAForm.get('supplierReference') as UntypedFormControl;
  }

  get rtaRequestDetails() {
    return this.RTAForm.get('rtaRequestDetails') as UntypedFormGroup;
  }

  get supplierOrCamName() {
    return this.RTAForm.get('rtaRequestDetails.supplierOrCamName') as UntypedFormControl;
  }

  get phone() {
    return this.RTAForm.get('rtaRequestDetails.phone') as UntypedFormControl;
  }

  get email() {
    return this.RTAForm.get('rtaRequestDetails.email') as UntypedFormControl;
  }
  
  get solarPurchaseOrder() {
    return this.RTAForm.get('rtaRequestDetails.solarPurchaseOrder') as UntypedFormControl;
  }

  get solarProductionOrder() {
    return this.RTAForm.get('rtaRequestDetails.solarProductionOrder') as UntypedFormControl;
  }

  get operation() {
    return this.RTAForm.get('rtaRequestDetails.operation') as UntypedFormControl;
  }

  get isNonconformingConditionCtq() {
    return this.RTAForm.get('rtaRequestDetails.isNonconformingConditionCtq') as UntypedFormControl;
  }

  get causeOfNonconformance() {
    return this.RTAForm.get('rtaRequestDetails.causeOfNonconformance') as UntypedFormControl;
  }

  get proposedCorrection() {
    return this.RTAForm.get('rtaRequestDetails.proposedCorrection') as UntypedFormControl;
  }

  get commentsOrSrp() {
    return this.RTAForm.get('rtaRequestDetails.commentsOrSrp') as UntypedFormControl;
  }

  get currentCondition() {
    return this.RTAForm.get('currentCondition') as UntypedFormArray;
  }

  get quantityOfNonconformingParts() {
    return this.RTAForm.get('rtaRequestDetails.quantityOfNonconformingParts') as UntypedFormControl;
  }

  get fromDate() {
    return this.RTAForm.get('rtaRequestDetails.fromDate') as UntypedFormControl;
  }

  get toDate() {
    return this.RTAForm.get('rtaRequestDetails.toDate') as UntypedFormControl;
  }

  get filesUploadAttachment() {
    return this.RTAForm.get('filesUploadAttachment') as UntypedFormControl;
  }


}
